/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-concat */
// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react'
import { useAccount } from 'wagmi'
import FunFactoryAbi from '../config/FunFactoryAbi.json'
import Input from '../components/Input.tsx'
import TextArea from '../components/TextArea.tsx'
import { readContract, writeContract, waitForTransactionReceipt } from 'wagmi/actions'
import ClipLoader from 'react-spinners/ClipLoader'
import { toast } from 'react-hot-toast'
import TopBar from '../components/TopBar.jsx'
import LogoUploadBox from '../components/LogoUploadBox.jsx'
import BannerUploadBox from '../components/BannerUploadBox.jsx'
import {
  web3Clients,
  chainLogos,
  feeAmounts,
  initialEth,
  coinNames,
  supportedChainIds,
  projectName,
  apiUrl
} from '../utils/constants.ts'
import {
  getFactoryAddress,
  getRouterAddress
} from '../utils/addressHelpers.ts'
import { Tooltip } from 'react-tooltip'
import { config } from '../config.jsx'
import Footer from '../components/Footer';

const App = () => {
  const [logoPreview, setLogoPreview] = useState<string | null>(null)
  const [logoFile, setLogoFile] = useState<File | null>(null)
  const [bannerPreview, setBannerPreview] = useState<string | null>(null)
  const [bannerFile, setBannerFile] = useState<File | null>(null)
  const logoFileInput = useRef<HTMLInputElement>(null)
  const bannerFileInput = useRef<HTMLInputElement>(null)
  const { address, chainId } = useAccount()
  const [maxWallet, setMaxWallet] = useState(1)
  const [chainIdNumber, setChainId] = useState(
    supportedChainIds.includes(chainId) ? chainId : 56
  )
  const [routers, setRouters] = useState(getRouterAddress(chainIdNumber))
  const [routerAddr, setRouter] = useState(Object.values(routers)[0])
  const [tokenName, setTokenName] = useState('')
  const [tokenSymbol, setTokenSymbol] = useState('')
  const [tokenDescription, setTokenDescription] = useState('')
  let [creating, setCreating] = useState(false)
  const [website, setWebsite] = useState('')
  const [telegram, setTelegram] = useState('')
  const [discord, setDiscord] = useState('')
  const [twitter, setTwitter] = useState('')
  const [depositAmount, setDepositAmount] = useState('')
  const [marketingWallet, setMarketingWallet] = useState(address)
  const [tokenTax, setTokenTax] = useState(0)
  const [accountBalance, setAccountBalance] = useState(0);
  const [showMoreOptions, setShowMoreOptions] = useState(false); // State for toggling optional sections
  const [telegramChatId, setTelegramChatId] = useState('')

  useEffect(() => {
    const fetchBalance = async () => {
      if (address && chainIdNumber) {
        let accountBalance = await web3Clients[chainIdNumber].eth.getBalance(
          address
        )
        accountBalance = web3Clients[chainIdNumber].utils.fromWei(
          accountBalance,
          'ether'
        )
        setAccountBalance(accountBalance)
        setMarketingWallet(address)
      }
    }
    if (address && chainId === 56) {
      fetchBalance()
    }
  }, [address, chainId])

  const onPumpItUpCreate = async () => {
    try {
      setCreating(true)

      if (!logoFile || !bannerFile) {
        toast.error('Please upload both a logo and a banner')
        setCreating(false)
        return
      }

      if (tokenTax > 5 || tokenTax < 0 || marketingWallet === '') {
        toast.error('Please enter correct marketing wallet address or tax amount')
        setCreating(false)
        return
      }
      if (Number(depositAmount) > 0) {
        let initialEthAmount
        initialEthAmount = Number(initialEth[chainId])

        let newEthAmount = initialEthAmount + Number(depositAmount)
        let newTokenAmount = (1073 * 10 ** 6 * initialEthAmount) / newEthAmount
        let tokenAmount = 1073 * 10 ** 6 - newTokenAmount
        let maxAmount = (1000000000 * maxWallet) / 100

        if (tokenAmount > maxAmount) {
          setCreating(false)
          toast.error(
            "You can't purchase more than " +
            ' ' +
            maxAmount.toLocaleString() +
            ' ' +
            ' tokens'
          )
          return false
        }
      }


      let create = await writeContract(config, {
        address: getFactoryAddress(chainId),
        abi: FunFactoryAbi,
        functionName: 'createDogWifHairLaunch',
        value: web3Clients[chainId].utils.toWei(String(Number(depositAmount)), 'ether'),
        args: [
          [
            tokenName,
            tokenSymbol,
            tokenDescription,
            website,
            twitter,
            telegram,
            discord,
            telegramChatId
          ],
          maxWallet.toString(),
          routerAddr,
          marketingWallet,
          tokenTax
        ],
      })

      await waitForTransactionReceipt(config, {
        hash: create
      })

      let otherInfo = await readContract(config, {
        address: getFactoryAddress(chainId),
        abi: FunFactoryAbi,
        functionName: 'getAllAddresses',
      })
      let funAddresses = otherInfo
      let uploadAddress
      let presaleAddress
      if (funAddresses) {
        uploadAddress = projectName + '-' + chainId + '-' + funAddresses[funAddresses.length - 1] + '.png';
        presaleAddress = funAddresses[funAddresses.length - 1]
      }

      // Upload Logo
      const logoFormData = new FormData()
      logoFormData.append('file', logoFile, uploadAddress)
      const logoResponse = await fetch(apiUrl + '/upload-logo', {
        method: 'POST',
        body: logoFormData
      })
      if (!logoResponse.ok) throw new Error('Failed to upload logo')

      // Upload Banner
      const bannerFormData = new FormData()
      bannerFormData.append('file', bannerFile, uploadAddress)
      const bannerResponse = await fetch(apiUrl + '/upload-banner', {
        method: 'POST',
        body: bannerFormData
      })
      if (!bannerResponse.ok) throw new Error('Failed to upload banner')

      toast.success(`Successfully ${tokenName} Meme Launch created`)
      const link = `/buy/?chain=${chainId}&address=${presaleAddress}`
      window.location.href = link
    } catch (err) {
      const errText = err.toString()
      if (errText.includes("connector")) {
        toast.error('There is a problem with your wallet connection. Please refresh and try again');
        setTimeout(function () {
          window.location.reload();
        }, 2000);
        setCreating(false);
        return;
      }
      console.error(err)
      toast.error('Failed to create token. Please try again later')
    } finally {
      setCreating(false)
    }
  }

  const [, setImageLogoFile] = useState(null)

  const handleImageLogoChange = file => {
    setImageLogoFile(file)
  }

  const [, setImageBannerFile] = useState(null)

  const handleImageBannerChange = file => {
    setImageBannerFile(file)
  }

  const LogoImageUpload = ({ onChange, className, style }) => {
    const handleLogoImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = e.target.files![0]
      setLogoFile(selectedFile)
      setLogoPreview(URL.createObjectURL(selectedFile))
      onChange(selectedFile)
    }
    const onButtonClick = () => {
      if (logoFileInput.current) {
        logoFileInput.current.click()
      }
    }
    return (
      <div className="w-full relative">
        <input
          type="file"
          ref={logoFileInput}
          accept="image/*"
          onChange={handleLogoImageChange}
          className="hidden"
        />
        <LogoUploadBox
          handleClick={onButtonClick}
          preview={logoPreview}
          onClear={() => {
            setLogoFile(null)
            setLogoPreview(null)
          }}
          className={'cursor-pointer w-full'}
          style={style}
        />
      </div>
    )
  }

  const BannerImageUpload = ({ onChange, className, style }) => {
    const handleBannerImageChange = (
      e: React.ChangeEvent<HTMLInputElement>
    ) => {
      const selectedFile = e.target.files![0]
      setBannerFile(selectedFile)
      setBannerPreview(URL.createObjectURL(selectedFile))
      onChange(selectedFile)
    }
    const onButtonClick = () => {
      if (bannerFileInput.current) {
        bannerFileInput.current.click()
      }
    }
    return (
      <div className="w-full relative">
        <input
          type="file"
          ref={bannerFileInput}
          accept="image/*"
          onChange={handleBannerImageChange}
          className="hidden"
        />
        <BannerUploadBox
          handleClick={onButtonClick}
          preview={bannerPreview}
          onClear={() => {
            setBannerFile(null)
            setBannerPreview(null)
          }}
          className={'cursor-pointer w-full'}
          style={style}
        />
      </div>
    )
  }

  const setMaxWalletAmount = value => {
    setMaxWallet(value)
  }

  const changeChain = value => {
    setChainId(value)
    const routers = getRouterAddress(value)
    setRouters(routers)
  }

  const setRouterAddress = value => {
    setRouter(value)
  }

  return (
    <div className="flex flex-col min-h-screen" style={{ background: 'var(--page-bg)' }}>
      <div className="flex-grow">
        <TopBar />
        <div className="max-w-7xl mx-auto pt-28 pb-16 px-4 sm:px-6">
          <section
            className="p-6 rounded-xl"
            style={{
              background: 'var(--card-bg)',
              border: '2px solid transparent',
              backgroundImage:
                'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}
          >
            {/* Header */}
            <div
              className="border-b pb-6 mb-8 text-center"
              style={{ borderColor: 'var(--border-color)' }}
            >
              <h1
                className="text-2xl sm:text-3xl font-bold"
                style={{ color: 'var(--text-primary)' }}
              >
                Create Coin
              </h1>
              <p className="mt-2" style={{ color: 'var(--text-primary)' }}>
                Note: data CANNOT be changed after creation
              </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-8">
              {/* Left Column: Media Uploads */}
              <div className="lg:w-1/3 flex flex-col gap-6">
                {/* Logo Upload */}
                <div>
                  <label
                    className="block text-sm font-medium mb-2"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    Upload Logo{' '}
                    <span style={{ color: 'var(--text-accent)' }}>*</span>
                  </label>
                  <div
                    className="p-4 rounded-xl"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--input-border)'
                    }}
                  >
                    <LogoImageUpload
                      onChange={handleImageLogoChange}
                      className="cursor-pointer"
                      style={undefined}
                    />
                  </div>
                </div>

                {/* Banner Upload */}
                <div>
                  <label
                    className="block text-sm font-medium mb-2"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    Upload Banner{' '}
                    <span style={{ color: 'var(--text-accent)' }}>*</span>
                  </label>
                  <div
                    className="p-4 rounded-xl"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--input-border)'
                    }}
                  >
                    <BannerImageUpload
                      onChange={handleImageBannerChange}
                      className="cursor-pointer"
                      style={undefined}
                    />
                  </div>
                </div>
              </div>

              {/* Right Column: Forms */}
              <div className="lg:w-2/3 flex flex-col gap-6">
                <h2
                  className="text-xl font-bold"
                  style={{ color: 'var(--text-primary)' }}
                >
                  General Information
                </h2>

                {/* Token Name */}
                <div>
                  <label
                    className="block text-sm font-medium mb-2"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    Token Name{' '}
                    <span style={{ color: 'var(--text-accent)' }}>*</span>
                  </label>
                  <div
                    className="p-4 rounded-xl"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--input-border)'
                    }}
                  >
                    <Input
                      placeholder="Enter the token name"
                      type="text"
                      changeValue={setTokenName}
                      value={tokenName}
                    />
                  </div>
                </div>

                {/* Ticker Name */}
                <div>
                  <label
                    className="block text-sm font-medium mb-2"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    Ticker Name{' '}
                    <span style={{ color: 'var(--text-accent)' }}>*</span>
                  </label>
                  <div
                    className="p-4 rounded-xl"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--input-border)'
                    }}
                  >
                    <Input
                      placeholder="Enter the ticker name"
                      type="text"
                      changeValue={setTokenSymbol}
                      value={tokenSymbol}
                    />
                  </div>
                </div>

                {/* Token Description */}
                <div>
                  <label
                    className="block text-sm font-medium mb-2"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    Token Description (Max 1000 characters){' '}
                    <span style={{ color: 'var(--text-accent)' }}>*</span>
                  </label>
                  <div
                    className="p-4 rounded-xl"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--input-border)'
                    }}
                  >
                    <TextArea
                      rows={4}
                      placeholder="Enter the description"
                      changeValue={setTokenDescription}
                      value={tokenDescription}
                    />
                  </div>
                </div>

                <h2
                  className="text-xl font-bold"
                  style={{ color: 'var(--text-primary)' }}
                >
                  Features
                </h2>

                {/* Max Wallet */}
                <div>
                  <label
                    className="block text-sm font-medium mb-2"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    Max Wallet (%){' '}
                    <span style={{ color: 'var(--text-accent)' }}>*</span>
                  </label>
                  <div
                    className="p-4 rounded-xl"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--input-border)'
                    }}
                  >
                    <div className="flex gap-2">
                      {[1, 2].map(percent => (
                        <button
                          key={percent}
                          className={`flex-1 py-2 rounded-lg transition-colors ${maxWallet === percent
                            ? 'bg-[var(--nav-button-active-bg)] text-[var(--nav-button-active-text)]'
                            : 'bg-[var(--nav-button-inactive-bg)] text-[var(--nav-button-inactive-text)]'
                            }`}
                          onClick={() => setMaxWalletAmount(percent)}
                          style={{
                            border: '1px solid var(--input-border)'
                          }}
                        >
                          {percent}%
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Snipe Amount */}
                <div>
                  <label
                    className="text-sm font-medium mb-2 flex items-center"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    Bundle Amount ({coinNames[chainIdNumber]})
                    <a id="snipe-tooltip" className="ml-1 cursor-pointer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="w-4 h-4"
                        style={{ color: 'var(--text-primary)' }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <Tooltip
                        anchorSelect="#snipe-tooltip"
                        className="z-50 max-w-xs p-3 rounded-lg shadow-lg"
                        style={{
                          background: 'var(--card-bg)',
                          color: 'var(--text-primary)',
                          border: '1px solid var(--input-border)'
                        }}
                        content="This is where you input how much you want to buy at launch. Bundling means automatically buying tokens with your dev wallet in the same txhash as the token deployment. This feature guarantees you will be the first buyer of your own token."
                      />
                    </a>
                  </label>
                  <div
                    className="p-4 rounded-xl"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--input-border)'
                    }}
                  >
                    <Input
                      placeholder="Enter Snipe Amount"
                      type="number"
                      changeValue={setDepositAmount}
                      value={depositAmount}
                    />
                  </div>
                </div>

                <div>
                  <label
                    className="text-sm font-medium mb-2 flex items-center"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    Marketing Fee Wallet Address
                    <a id="fee-tooltip" className="ml-1 cursor-pointer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="w-4 h-4"
                        style={{ color: 'var(--text-primary)' }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <Tooltip
                        anchorSelect="#fee-tooltip"
                        className="z-50 max-w-xs p-3 rounded-lg shadow-lg"
                        style={{
                          background: 'var(--card-bg)',
                          color: 'var(--text-primary)',
                          border: '1px solid var(--input-border)'
                        }}
                        content="You can add fee on token. Marketing wallet Tax will start after migration to pancake swap"
                      />
                    </a>
                  </label>
                  <div
                    className="p-4 rounded-xl"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--input-border)'
                    }}
                  >
                    <Input
                      placeholder="Enter Marketing Wallet Address"
                      type="string"
                      changeValue={setMarketingWallet}
                      value={marketingWallet}
                    />
                  </div>
                </div>

                <div>
                  <label
                    className="text-sm font-medium mb-2 flex items-center"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    Marketing Fee Amount (Up to 5%)
                  </label>
                  <div
                    className="p-4 rounded-xl"
                    style={{
                      background: 'var(--input-bg)',
                      border: '1px solid var(--input-border)'
                    }}
                  >
                    <Input
                      placeholder="Enter Marketing Fee Amount"
                      type="number"
                      changeValue={setTokenTax}
                      value={tokenTax}
                    />
                  </div>
                </div>

                {/* More Options Toggle */}
                <div
                  className="flex items-center gap-2 cursor-pointer"
                  onClick={() => setShowMoreOptions(!showMoreOptions)}
                >
                  <p
                    className="text-sm"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    {showMoreOptions ? 'Hide more options' : 'Show more options'}
                  </p>
                  <svg
                    className={`w-4 h-4 transform ${showMoreOptions ? 'rotate-180' : ''
                      }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>

                {/* Optional Sections */}
                {showMoreOptions && (
                  <>
                    <h2
                      className="text-xl font-bold"
                      style={{ color: 'var(--text-primary)' }}
                    >
                      Social Links
                    </h2>

                    {/* Telegram */}
                    <div>
                      <label
                        className="block text-sm font-medium mb-2"
                        style={{ color: 'var(--text-primary)' }}
                      >
                        Telegram portal
                      </label>
                      <div
                        className="p-4 rounded-xl"
                        style={{
                          background: 'var(--input-bg)',
                          border: '1px solid var(--input-border)'
                        }}
                      >
                        <Input
                          placeholder="Enter the telegram URL"
                          type="text"
                          changeValue={setTelegram}
                          value={telegram}
                        />
                      </div>
                    </div>

                    <div>
                      <label
                        className="text-sm font-medium mb-2 flex items-center"
                        style={{ color: 'var(--text-primary)' }}
                      >
                        Public group link (For buy bot - @dogwifhair_buy_bot)
                        <a id="chatId-tooltip" className="ml-1 cursor-pointer">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            className="w-4 h-4"
                            style={{ color: 'var(--text-primary)' }}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          <Tooltip
                            anchorSelect="#chatId-tooltip"
                            className="z-50 max-w-xs p-3 rounded-lg shadow-lg"
                            style={{
                              background: 'var(--card-bg)',
                              color: 'var(--text-primary)',
                              border: '1px solid var(--input-border)'
                            }}
                            content="Telegram public group link for buy bot. Add the buy bot as admin before launching your token."
                          />
                        </a>

                      </label>
                      <div
                        className="p-4 rounded-xl"
                        style={{
                          background: 'var(--input-bg)',
                          border: '1px solid var(--input-border)'
                        }}
                      >
                        <Input
                          placeholder="Telegram Chat Id"
                          label=""
                          type="text"
                          changeValue={setTelegramChatId}
                          value={telegramChatId}
                        />
                      </div>
                    </div>

                    {/* Twitter */}
                    <div>
                      <label
                        className="block text-sm font-medium mb-2"
                        style={{ color: 'var(--text-primary)' }}
                      >
                        X Link
                      </label>
                      <div
                        className="p-4 rounded-xl"
                        style={{
                          background: 'var(--input-bg)',
                          border: '1px solid var(--input-border)'
                        }}
                      >
                        <Input
                          placeholder="Enter the X URL"
                          type="text"
                          changeValue={setTwitter}
                          value={twitter}
                        />
                      </div>
                    </div>

                    {/* Discord */}
                    <div>
                      <label
                        className="block text-sm font-medium mb-2"
                        style={{ color: 'var(--text-primary)' }}
                      >
                        Other Socials
                      </label>
                      <div
                        className="p-4 rounded-xl"
                        style={{
                          background: 'var(--input-bg)',
                          border: '1px solid var(--input-border)'
                        }}
                      >
                        <Input
                          placeholder="Enter Social URL"
                          type="text"
                          changeValue={setDiscord}
                          value={discord}
                        />
                      </div>
                    </div>

                    {/* Website */}
                    <div>
                      <label
                        className="block text-sm font-medium mb-2"
                        style={{ color: 'var(--text-primary)' }}
                      >
                        Website
                      </label>
                      <div
                        className="p-4 rounded-xl"
                        style={{
                          background: 'var(--input-bg)',
                          border: '1px solid var(--input-border)'
                        }}
                      >
                        <Input
                          placeholder="Enter the website URL"
                          type="text"
                          changeValue={setWebsite}
                          value={website}
                        />
                      </div>
                    </div>

                    <>
                      <h2
                        className="text-xl font-bold"
                        style={{ color: 'var(--text-primary)' }}
                      >
                        DEX
                      </h2>

                      {/* Network Selector */}
                      <div>
                        <label
                          className="block text-sm font-medium mb-2"
                          style={{ color: 'var(--text-primary)' }}
                        >
                          Network
                        </label>
                        <div
                          className="p-4 rounded-xl"
                          style={{
                            background: 'var(--input-bg)',
                            border: '1px solid var(--input-border)'
                          }}
                        >
                          <div className="flex flex-wrap gap-2">
                            {supportedChainIds.map(id => (
                              <button
                                key={id}
                                className={`p-2 rounded-lg transition-all ${chainIdNumber === id
                                  ? 'nav-button active'
                                  : 'nav-button'
                                  }`}
                                onClick={() => changeChain(id)}
                                style={{
                                  background: 'var(--nav-button-inactive-bg)',
                                  border: '1px solid var(--nav-button-inactive-border)',
                                  opacity: chainIdNumber === id ? 1 : 0.7
                                }}
                              >
                                <img
                                  src={chainLogos[id]}
                                  alt={`Chain ${id}`}
                                  className="w-8 h-8"
                                />
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>

                      {/* DEX Selector */}
                      <div>
                        <label
                          className="block text-sm font-medium mb-2"
                          style={{ color: 'var(--text-primary)' }}
                        >
                          Dex
                        </label>
                        <div
                          className="p-4 rounded-xl"
                          style={{
                            background: 'var(--input-bg)',
                            border: '1px solid var(--input-border)'
                          }}
                        >
                          <div className="flex flex-wrap gap-2">
                            {Object.entries(routers).map(([key, value]) => (
                              <button
                                key={key}
                                className={`px-4 py-2 rounded-lg transition-colors ${routerAddr === value
                                  ? 'nav-button active'
                                  : 'nav-button'
                                  }`}
                                onClick={() => setRouterAddress(value)}
                                style={{
                                  border: '1px solid var(--nav-button-inactive-border)',
                                  color:
                                    routerAddr === value
                                      ? 'var(--nav-button-active-text)'
                                      : 'var(--nav-button-inactive-text)'
                                }}
                              >
                                {key}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    </>
                  </>
                )}
              </div>
            </div>
          </section>
          {/* Create Button */}
          <div className="mt-8 flex justify-center">
            <button
              disabled={
                tokenName === '' ||
                tokenSymbol === '' ||
                tokenDescription === '' ||
                creating ||
                !logoFile ||
                !bannerFile ||
                feeAmounts[chainId] + Number(depositAmount) > accountBalance
              }
              onClick={onPumpItUpCreate}
              className="px-8 py-3 rounded-lg font-bold transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
              style={{
                background: 'var(--button-bg)',
                color: 'var(--button-text)',
                minWidth: '200px'
              }}
            >
              {creating ? (
                <ClipLoader
                  color="var(--button-text)"
                  loading={true}
                  size={24}
                />
              ) : (
                'Create Coin'
              )}
            </button>
          </div>        </div>
      </div>
      <Footer />
    </div>
  )
}

export default App
